import { list2, get } from '@/api/crud'

const set = property => (state, payload) => (state[property] = payload)

const state = {
  pedidosSelecionados: [], // Pedidos que são marcados no GRID
  pedidos: [], // OBJ de pedidos do GRID
  filtroAtual: null,
  filtroStatus: false,
  loading: true
}

const mutations = {
  SETPEDIDOS: set('pedidos'),
  SETFILTROSTATUS: set('filtroStatus'),
  SETPEDIDOSSELECIONADOS: set('pedidosSelecionados'),
  SETLOADING: set('loading'),
  SETFILTROATUAL: set('filtroAtual')
}

const actions = {
  async loadPedidos ({ commit }, filter) {
    // console.log('loadPedidos')
    // // console.log(filter)
    // commit('SETPEDIDOSSELECIONADOS', [])
    // commit('SETPEDIDOS', [])
    // commit('SETLOADING', true)
    // try {
    //   // const data = await list('/site/carrinhocrud', true, filter) // Rota Antiga
    //   const data = await list('/crm/listagemdepedidos', true, filter)
    //   setTimeout(() => {
    //     commit('SETPEDIDOS', data)
    //     commit('SETLOADING', false)
    //   }, 500)
    //   return data
    // } catch (error) {
    //   // console.log(error)
    //   return error
    // }
  },
  async loadPedidosFiltro ({ commit }, dados) {
    console.log('loadPedidosFiltro')
    // console.log(dados)
    commit('SETPEDIDOSSELECIONADOS', [])
    commit('SETPEDIDOS', [])
    commit('SETLOADING', true)
    commit('SETFILTROATUAL', dados.filtro)
    try {
      // console.log('loadPedidosFiltro')
      // console.log(dados)
      const data = await list2('/crm/listagemdepedidos', dados.filtro, dados.pagination)
      if (data.data.length) commit('SETPEDIDOS', data)
      commit('SETLOADING', false)
      commit('SETFILTROSTATUS', true)
      return data
    } catch (error) {
      commit('SETLOADING', false)
      // console.log(error)
      return error
    }
  },
  async getPedido ({ commit }, id) {
    try {
      const data = await get('/crm/listagemdepedidos', true, id)
      return data
    } catch (error) {
      // console.log(error)
      return error
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
